import API from 'services/API';

export default function makePwdSignConstant() {
  return API.request({
    method: 'PUT',
    url: '/profile/makePwdSignConstant',
  });
}
